/**
 * Recent searches (D-91): kept on this device only (never sent), newest first, at most 8, the
 * same words once whatever their case. A longer search replaces the start of it typed before
 * ("sar" then "saree" keeps "saree"). Shown on the empty search page.
 */
import { safeStorage } from './storage'

export const RECENT_SEARCHES_KEY = 'angadi.recentSearches'
export const MAX_RECENT_SEARCHES = 8

export function recentSearches(): string[] {
  try {
    const v: unknown = JSON.parse(safeStorage.get(RECENT_SEARCHES_KEY) ?? '[]')
    return Array.isArray(v) ? v.filter((x): x is string => typeof x === 'string') : []
  } catch {
    return []
  }
}

export function addRecentSearch(q: string): string[] {
  const term = q.trim().slice(0, 100)
  if (!term) return recentSearches()
  const key = term.toLowerCase()
  const next = [term, ...recentSearches().filter((x) => !key.startsWith(x.toLowerCase()))].slice(
    0,
    MAX_RECENT_SEARCHES,
  )
  safeStorage.set(RECENT_SEARCHES_KEY, JSON.stringify(next))
  return next
}

export function clearRecentSearches(): void {
  safeStorage.remove(RECENT_SEARCHES_KEY)
}
